module.exports = __webpack_public_path__ + "static/media/insta-18.575ea051.png";